import { usePassbook } from '@/shared/lib/passbook';
import { PageHeader } from '@/shared/components/page-header';
import { TiersSettingsSection } from './tiers-settings-section';
import { TierOverrideSection } from './tier-override-section';

/** Níveis de fidelidade do passbook (Gestão do Programa › Tiers). */
export function TiersPage() {
  const { idPassbook, passbook } = usePassbook();
  return (
    <>
      <PageHeader
        title="Tiers"
        description={`${passbook.organizationName} — níveis de fidelidade`}
      />
      <TiersSettingsSection idPassbook={idPassbook} passbook={passbook} />
    </>
  );
}

/** Upgrade/downgrade manual do nível de um cliente (Gestão do Programa › Ajustar cliente). */
export function TierOverridePage() {
  const { idPassbook, passbook } = usePassbook();
  return (
    <>
      <PageHeader
        title="Ajustar cliente"
        description={`${passbook.organizationName} — nível manual de um cliente`}
      />
      <TierOverrideSection idPassbook={idPassbook} passbook={passbook} />
    </>
  );
}
